import type { AxShareConfigModel } from "@/generated/models";
import { queryOptions } from "@tanstack/vue-query";
import { getConfig } from "ls/api/cloud/user";
import { STALE } from "ls/queries/staleTime";

declare global {
  interface AxureCloudInitialData {
    config?: AxShareConfigModel;
  }
}

export const queries = {
  config: () =>
    queryOptions({
      queryKey: ["config"] as const,
      queryFn: getConfig,
      staleTime: STALE.INFINITY,
      initialData: () => {
        try {
          return globalThis.__AxureCloudInitialData.config;
        } catch {
          return undefined;
        }
      },
    }),
};
